import React from 'react';
import { EditorStringModel } from '../Types/EditorString';
import EditorString from '../Components/EditorString/EditorString';
import clsx from 'clsx';

interface RichTextBlockProps {
  text: EditorStringModel;
  textMobile?: EditorStringModel;
  additionalPaddingX: boolean;
  additionalPaddingY: boolean;
}

const RichTextBlock = ({
  text,
  textMobile,
  additionalPaddingX,
  additionalPaddingY,
}: RichTextBlockProps) => {
  return (
    <div
      className={clsx(
        additionalPaddingX && 'lg:px-10',
        additionalPaddingY && 'lg:py-10'
      )}
    >
      {/* Desktop */}
      <div className={clsx(!!textMobile?.value && 'hidden lg:block')}>
        <EditorString {...text} />
      </div>
      {/* Mobile */}
      {!!textMobile?.value && (
        <div className="lg:hidden">
          <EditorString {...textMobile} />
        </div>
      )}
    </div>
  );
};

export default RichTextBlock;
